export default __webpack_public_path__ + "static/media/car-rout.35f01ff8.svg";